import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import HeroSecondaryWrapper from '@components/hero-secondary-wrapper'
import { useEffect, useState, useRef } from 'react'
import useResizeObserver from '@hooks/useResizeObserver'
import Video from '@components/atoms/video'
import { PauseButton, PlayButton } from '@components/atoms/icons'
import { useStyles } from './hero-events.styles'

const Hero = (props) => {
  const {
    heroImage, heroImageMobile, featuredEvent,
  } = props
  const [ref, entry] = useResizeObserver()
  const [offset, setOffset] = useState(0)
  const [bottomMargin, setBottomMargin] = useState(0)

  const videoBackground = heroImage && heroImage.url.includes('video') && heroImage.url

  const images = {
    sm: heroImageMobile
      ? `${heroImageMobile.url}?fm=jpg&fl=progressive&q=80`
      : heroImage && `${heroImage.url}?fm=jpg&fl=progressive&q=80`,
    lg: heroImage
      ? `${heroImage.url}?fm=jpg&h=1200&w=1800&fit=fill&fl=progressive&q=80`
      : '',
  }

  const styles = useStyles({ images, offset, bottomMargin })

  useEffect(() => {
    if (entry?.contentRect?.height) {
      setOffset(entry.contentRect.height * 0.5)
      setBottomMargin(entry.contentRect.height * 0.5)
    }
  }, [entry?.contentRect?.height])

  const videoRef = useRef()

  const handlePause = () => {
    videoRef.current.pause()
  }
  const handlePlay = () => {
    videoRef.current.play()
  }

  return (
    <Box
      className={styles.root}
      display="flex"
      flexDirection="column"
      data-testid="events-page-hero"
    >
      {videoBackground ? (
        <>
        <Video
          src={videoBackground}
          autoPlay
          muted
          loop
          playsInline
          className={styles.videoContainer}
          ref={videoRef}
        />
        <div className={styles.buttonContainer}>
          <button title="Pause background video" type="button" className={styles.videoButton} onClick={handlePause}>
            <PauseButton />
          </button>
          <button title="Play background video" type="button" className={styles.videoButton} onClick={handlePlay}>
            <PlayButton />
          </button>
        </div>
        </>
      ) : (
        <Box className={styles.imageContainer} />
      )}
      {featuredEvent && (
        <Box className={styles.ctaContainer}>
          <HeroSecondaryWrapper
            ref={ref}
            featuredEvent={featuredEvent}
          />
        </Box>
      )}
    </Box>
  )
}

Hero.propTypes = {
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  heroImageMobile: PropTypes.shape({
    url: PropTypes.string,
  }),
  featuredEvent: PropTypes.object,
}

export default Hero
